<div class="timeline-view-box-container">
    <div class="timeline-view" id="wf-featureTimeLineId" (click)="changepanelOpened()">
        <!-- circle which green or red according to status -->
        <div [class]="getClassForDot()"></div>

        <!-- row of worflow -->
        <div class="fit-width">
            <div class="drop-icon fit-width" *ngIf="panelOpened">
                <span class="cursor icon-container" [matTooltip]="collapseIcon"><mat-icon>remove</mat-icon></span>
            </div>
            <div class="drop-icon fit-width" *ngIf="!panelOpened ">
                <span class="cursor icon-container" [matTooltip]="expandIcon"><mat-icon>add</mat-icon></span>
            </div>
        </div>
        <div class="fit-width ellipses wfName" [matTooltip]="workflow.workflowName">{{workflow.workflowName}}</div>
        <div class="fit-width" [matTooltip]="workflow.startTime">{{workflow.startTime | date}}</div>
        <div class="fit-width">
            <div class="queueTime">
                <div [matTooltip]="workflow.duration | durationFormatter">{{workflow.duration | durationFormatter}}</div>
            </div>
        </div>
        <div class="fit-width">
            <app-type-specific-status [type]=true specifiedType="workflow" statusName={{workflow.specificStatus}}>
            </app-type-specific-status>
        </div>
    </div>

    <!-- to get qualty gate view on expand  row of worflow -->
    <div class="gates-view" *ngIf="panelOpened ">
        <app-quality-gates-fe-wf [jobId]="workflow['jobId']"></app-quality-gates-fe-wf>
    </div>
</div>